const GameState = {
	uninitialized: -1,
	playing: 0,
	done: 1,
	results: 2,
};

document.setDefaultFontSize = function() {
	const container = document.getElementById('game-container');
	const containerWidth = container.clientWidth;
	let fontSize = Math.round(20 * containerWidth / 1055);
	document.documentElement.style.setProperty('--default-font-size', `${fontSize}px`);
}

document.setGameContainerSize = function() {
	const width = window.innerWidth;
	const height = window.innerHeight;
	const container = document.getElementById('game-ratio-container');

	if (height < (width * 2.8 / 4)) {
		container.style.width = `${Math.floor(height * 4 / 2.8)}px`;
	} else {
		container.style.width = `${width}px`;
	}
}

document.computeSizes = function() {
	document.setGameContainerSize();
	document.setDefaultFontSize();
}

document.Game = {
	state: GameState.uninitialized,
	currentQuestionIndex: 0,
	questions: [
		{
			sentence: 'En cas d’inflammation, il est possible<br/>d’appliquer une compresse froide<br/>sur son genou arthrosique',
			answer: 1,
			details: '<p><strong>C’est vrai !</strong><br />Le froid aide à atténuer la douleur et le gonflement. Veillez cependant à ne pas mettre la glace directement au contact de votre peau<sup>4</sup>.</p>',
			reference: '<p>4. Société Arthrite (2018). Arthrose Causes, symptômes, traitements. [en ligne] https://arthrite.ca/a-propos-de-l-arthrite/les-types-d-arthrite-de-a-a-z/types/arthrose/prise-en-charge-personnelle-de-l-arthrose - consulté le 13.09.2022</p>',
		},
		{
			sentence: 'En dehors des crises inflammatoires,<br/>je dois économiser mes articulations',
			answer: 0,
			details: '<p><strong>Certainement pas !</strong><br />En dehors des crises inflammatoires, immobiliser vos articulations peut aggraver votre arthrose <sup>1</sup> ! Une pratique sportive adaptée est donc indispensable en phase chronique <sup>2</sup>.</p>',
			reference: '<p>1. Fouquet, B., & Jaume-Guichard, P. (2021). Acivités physiques, sédentarité, comorbidités et arthrose. Revue du Rhumatisme Monographies, 88(3), 194-202.<br />\n' +
				'2. Ziltener, J., Leal, S., Borloz, S. (2012), Activités physiques – sport et arthrose, Rev Med Suisse, -2, no. 332, 564-570.</p>'
		},
		{
			sentence: 'Il est important d’évoquer<br/>son arthrose du genou avec son entourage',
			answer: 1,
			details: '<p><strong>Absolument !</strong><br />En partageant votre ressenti et en expliquant votre gêne à vos proches, vous les aiderez à mieux vous comprendre et vous soutenir.</p>',
		},
		{
			sentence: 'Il est essentiel de suivre son arthrose<br/>du genou avec un spécialiste',
			answer: 1,
			details: '<p><strong>Absolument !</strong> Un bilan annuel médical est primordial <sup>3</sup> pour évaluer l’évolution de votre arthrose et mettre en place des mesures pour éviter autant que possible son aggravation.</p>',
			reference: '<p>3. AFLAR (2011). Arthrose : vérités, vécus, besoins et attentes des personnes malades. [en ligne] https://www.thermes-dax.com/wp-content/uploads/2018/03/brochure-enquete-arthrose.pdf. Consulté le 23.06.2022.</p>',
		},
		{
			sentence: 'Ce n’est pas grave si l’arthrose<br/>du genou est douloureuse',
			answer: 0,
			details: '<p><strong>Bien sûr que si !</strong><br />Ne pas traiter votre douleur risque d’affecter votre moral, et par la même occasion vos loisirs, votre vie familiale, sociale et intime <sup>3</sup>.</p>',
			reference: '<p>3. AFLAR (2011). Arthrose : vérités, vécus, besoins et attentes des personnes malades. [en ligne] https://www.thermes-dax.com/wp-content/uploads/2018/03/brochure-enquete-arthrose.pdf. Consulté le 23.06.2022.</p>',
		},
		{
			sentence: 'L\'arthrose du genou résulte d\'un seul<br/>facteur de risque',
			answer: 0,
			details: '<p><strong>Au contraire</strong>, votre arthrose du genou est une maladie dite « multifactorielle ». Cela signifie qu’elle survient lorsque plusieurs facteurs de risque sont associés, comme par exemple l’âge, le surpoids, l’hérédité, la ménopause ou encore un traumatisme <sup>5,6,7</sup>.</p>',
			reference: '<p>5. Inserm (2012). Arthrose. [en ligne] https://www.inserm.fr/dossier/arthrose/ - consulté le 08.06.2022<br />' +
				'6. Millán, Marta Martín, and Santos Castañeda. (2013) "Estrogènes, arthrose et inflammation." Revue du rhumatisme 80.4 : 350-356.<br />' +
				'7. De Jaeger, C., & Cherin, P. (2011). L’arthrose : une nouvelle maladie inflammatoire ? Actualités fondamentales et thérapeutiques. Médecine & Longévité, 3(3), 116-136.<br />' +
				'</p>',
		},
	],
	render() {
		// Hide all game state
		const gameStates = document.getElementsByClassName('game-state');
		for (let i = 0; i < gameStates.length; i++) {
			if (!gameStates[i].classList.contains('hidden')) {
				gameStates[i].classList.add('hidden');
			}
		}
		// Call method to prepare everything then display the current state
		switch (this.state) {
			case GameState.playing:
				this._renderQuestions();
				document.getElementById('state-playing').classList.remove('hidden')
				break;
			case GameState.done:
				document.getElementById('state-done').classList.remove('hidden')
				break;
			case GameState.results:
				this._renderResults();
				document.getElementById('state-results').classList.remove('hidden')
				break;
		}
	},
	_renderQuestions() {
		// Reset game state
		const oldDropZones = document.getElementsByClassName('answer-column-drop-zone');
		for (let i = 0; i < oldDropZones.length; i++) {
			oldDropZones[i].innerHTML = "";
		}
		document.getElementById('options-area').innerHTML = "";

		// Create answer
		const container = document.getElementById('options-area');

		let optionsHtml = '';
		this.questions.forEach((question, i) => {
			optionsHtml += `<div class="option" draggable="true" data-id="${i}">${question.sentence}</div>`;
		});
		container.innerHTML = optionsHtml;

		/** Handle drag & drop **/
		this.showingTooltip = false;
		this.selectedItem = null;
		this.successCount = 0;

		const optionsElements = document.getElementsByClassName("option");
		for (let i = 0; i < optionsElements.length; i++) {
			optionsElements[i].addEventListener("dragstart", (ev) => {
				if (this.showingTooltip) {
					ev.preventDefault();
					return;
				}
				this.selectedItem = ev.currentTarget;
			});
		}

		const dropZones = document.getElementsByClassName("answer-column-drop-zone");
		for (let i = 0; i < dropZones.length; i++) {
			dropZones[i].addEventListener("dragover", (ev) => {
				ev.preventDefault();
			});
			dropZones[i].addEventListener("drop", (ev) => {
				if (dropZones[i].children.length >= 3) {
					// We can't have more than 3 item in a column
					ev.preventDefault();
					return;
				}

				// Add item to dropZone
				const answerElement = this.selectedItem?.cloneNode(true);
				if (!answerElement) return; // For duplicated events when we restart
				this.selectedItem.classList.add('hidden-opacity');
				dropZones[i].appendChild(answerElement);

				const relatedQuestion = this.questions[this.selectedItem.dataset.id];
				const isSuccess = +dropZones[i].dataset.value === relatedQuestion.answer;

				if (isSuccess) {
					this.showingTooltip = true;
					answerElement.classList.add("success");
					this.selectedItem = null;
					this.successCount += 1;
					// Show tooltip
					const successDiv = document.createElement('div');
					successDiv.innerHTML = relatedQuestion.details;
					successDiv.setAttribute("id", "success-message");
					answerElement.appendChild(successDiv);

					const refArea = document.getElementById("reference-area");
					refArea.innerHTML = relatedQuestion.reference || "";

					setTimeout(() => {
						answerElement.removeChild(successDiv);
						refArea.innerHTML = "";
						this.showingTooltip = false;
					}, 2000);

					if (this.successCount === this.questions.length) {
						setTimeout(() => {
							this.showSuccessScreen();
						}, 2000);
					}
					return;
				}

				// If error, hide item temporarily, show tooltip then revert
				this.showingTooltip = true;
				answerElement.classList.add("error");

				const errorDiv = document.createElement('div');
				errorDiv.innerHTML = "<strong>Oups !</strong> Ce n'est pas ici.";
				errorDiv.setAttribute("id", "error-message");
				answerElement.appendChild(errorDiv);

				setTimeout(() => {
					dropZones[i].removeChild(answerElement);
					this.selectedItem.classList.remove('hidden-opacity');
					this.selectedItem = null;
					this.showingTooltip = false;
				}, 2000);
			});
		}
	},
	_renderResults() {
		let truthOptionsHtml = '';
		let errorsOptionsHtml = '';
		// We need to change a little bit the order to match screen that were validated
		[
			{ question: this.questions[4], i: 4 },
			{ question: this.questions[1], i: 1 },
			{ question: this.questions[5], i: 5 },
			{ question: this.questions[0], i: 0 },
			{ question: this.questions[3], i: 3 },
			{ question: this.questions[2], i: 2 },
		].forEach(({ question, i }) => {
			const html = `<div id="option-${i}" onclick="Game.showAnswer('${i}')" data-id="${i}">${question.sentence}</div>`;
			if (+question.answer === 1) {
				truthOptionsHtml += html;
			} else {
				errorsOptionsHtml += html;
			}
		});

		document.getElementById('results-truth').innerHTML = truthOptionsHtml;
		document.getElementById('results-error').innerHTML = errorsOptionsHtml;
	},
	showAnswer(i) {
		// Clean previous if exist
		const existingTooltip = document.getElementById("success-message");
		if (existingTooltip) {
			existingTooltip.remove();
		}

		// Show answer
		const relatedQuestion = this.questions[i];
		const optionElement = document.getElementById(`option-${i}`);

		const successDiv = document.createElement('div');
		successDiv.innerHTML = relatedQuestion.details;
		successDiv.setAttribute("id", "success-message");
		optionElement.appendChild(successDiv);

		const refArea = document.getElementById("results-reference-area");
		refArea.innerHTML = relatedQuestion.reference || "";
	},
	answer() {

	},
	restart() {
		this.state = GameState.playing;
		this.render();
	},
	showSuccessScreen() {
		this.state = GameState.done;
		this.render();
	},
	seeResults() {
		this.state = GameState.results;
		this.render();
	}
}

document.computeSizes();
document.Game.restart();
addEventListener('resize', document.computeSizes);
